import axios from 'axios';

const getDocuments = ({ year }) =>
  axios.get(`/ultratax_input_screens_prune/documents?year=${year}`);

const getPruneSets = ({ extractedDocumentId, year }) =>
  axios.get(
    `/ultratax_input_screens_prune/prune_sets?extracted_document_id=${extractedDocumentId}&year=${year}`,
  );

const updatePruneSet = ({ id, companyId }) =>
  axios.patch(`/ultratax_input_screens_prune/prune_sets/${id}`, {
    company_id: companyId,
  });

const dryRun = ({ extractedDocumentId, year, priorYearPruneSetId }) =>
  axios.post(`/ultratax_input_screens_prune/dry_run`, {
    extracted_document_id: extractedDocumentId,
    year,
    prior_year_prune_set_id: priorYearPruneSetId,
  });

const execute = ({ extractedDocumentId, year, priorYearPruneSetId }) =>
  axios.post(`/ultratax_input_screens_prune/execute`, {
    extracted_document_id: extractedDocumentId,
    year,
    prior_year_prune_set_id: priorYearPruneSetId,
  });

const deletePruneSet = ({ id }) =>
  axios.delete(`/ultratax_input_screens_prune/prune_sets/${id}`);

const deleteAllPruneSets = ({ year }) =>
  axios.delete(`/ultratax_input_screens_prune/prune_sets?year=${year}`);

export default {
  getDocuments,
  getPruneSets,
  updatePruneSet,
  dryRun,
  execute,
  deletePruneSet,
  deleteAllPruneSets,
};
